import { useState } from 'react';
import MainLayout from "../../layouts/MainLayout";
import { toast } from 'react-toastify';
import { API_URL } from '../../utils/constants';
import { useTranslation } from 'react-i18next';
import {
  IoChatboxOutline, IoMailOutline, IoCallOutline,
  IoSendOutline,
} from "react-icons/io5";
import "./styles.css";

function ContactUsPage() {
  const { t } = useTranslation();
  const [storeLoading, setStoreLoading] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone_number: '',
    subject: '',
    message: ''
  });

  const subjectOptions = [
    { value: '', label: t('contact.subject_options.select') },
    { value: 'general',       label: t('contact.subject_options.general') },
    { value: 'support',       label: t('contact.subject_options.technical') },
    { value: 'business',      label: t('contact.subject_options.deal') },
    { value: 'feedback',      label: t('contact.subject_options.note') },
    { value: 'delete_acount', label: t('contact.subject_options.delete_account') },
    { value: 'delete_data',   label: t('contact.subject_options.delete_data') },
    { value: 'other',         label: t('contact.subject_options.other') },
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.fullName || !formData.email || !formData.subject || !formData.message) {
      toast.error('يرجى ملئ جميع المعلومات.');
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error('يرجى إدخال عنوان بريد إلكتروني صالح.');
      return;
    }

    setStoreLoading(true);
    fetch(API_URL + '/contact-us/store', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        fullname:     formData.fullName,
        email:        formData.email,
        phone_number: formData.phone_number,
        subject:      formData.subject,
        message:      formData.message
      })
    })
    .then(r => r.json())
    .then(data => {
      setStoreLoading(false);
      if (data.success) {
        toast.success('تم ارسال الرسالة بنجاح');
        setFormData({ fullName: '', email: '', phone_number: '', subject: '', message: '' });
      } else {
        toast.error(data.message || 'حدث خطأ أثناء ارسال الرسالة');
      }
    })
    .catch(() => {
      setStoreLoading(false);
      toast.error('حدث خطأ أثناء ارسال الرسالة');
    });
  };

  const isDisabled = storeLoading || !formData.fullName || !formData.email || !formData.subject || !formData.message;

  return (
    <MainLayout isTopBar screenTitle={t('contact.title')}>
      <div className="cu-wrap" dir="rtl">

        <div className="cu-hero">
          <div className="cu-hero__icon">
            <IoChatboxOutline size={30} />
          </div>
          <h1 className="cu-hero__title">{t('contact.title')}</h1>
          <p className="cu-hero__sub">{t('contact.subtitle')}</p>
        </div>

        {/* Quick contact info */}
        <div className="cu-info-row">
          <div className="cu-info-card">
            <div className="cu-info-card__icon"><IoMailOutline size={18} /></div>
            <div className="cu-info-card__text">
              <p className="cu-info-card__label">البريد الإلكتروني</p>
              <p className="cu-info-card__value">contact@aqaraty.ly</p>
            </div>
          </div>
          <div className="cu-info-card">
            <div className="cu-info-card__icon"><IoCallOutline size={18} /></div>
            <div className="cu-info-card__text">
              <p className="cu-info-card__label">الهاتف</p>
              <p className="cu-info-card__value" dir="ltr">+218 555 555 555</p>
            </div>
          </div>
        </div>

        {/* Form */}
        <div className="cu-form-card">
          <p className="cu-form-card__title">أرسل لنا رسالة</p>

          <form onSubmit={handleSubmit}>
            <div className="cu-row">
              <div className="cu-group">
                <label className="cu-label">
                  {t('contact.fullname')} <span>*</span>
                </label>
                <input
                  className="cu-input"
                  type="text"
                  name="fullName"
                  placeholder={t('contact.fullname_placeholder')}
                  value={formData.fullName}
                  onChange={handleInputChange}
                />
              </div>
              <div className="cu-group">
                <label className="cu-label">
                  {t('contact.email')} <span>*</span>
                </label>
                <input
                  className="cu-input"
                  type="email"
                  name="email"
                  placeholder={t('contact.email_placeholder')}
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="cu-group">
              <label className="cu-label">
                {t('contact.phone_number')}
              </label>
              <input
                className="cu-input"
                type="text"
                name="phone_number"
                placeholder={t('contact.phone_number_placeholder')}
                value={formData.phone_number}
                onChange={handleInputChange}
              />
            </div>

            <div className="cu-group">
              <label className="cu-label">
                {t('contact.subject')} <span>*</span>
              </label>
              <select
                className="cu-select"
                name="subject"
                value={formData.subject}
                onChange={handleInputChange}
              >
                {subjectOptions.map(o => (
                  <option key={o.value} value={o.value}>{o.label}</option>
                ))}
              </select>
            </div>

            <div className="cu-group">
              <label className="cu-label">
                {t('contact.message')} <span>*</span>
              </label>
              <textarea
                className="cu-textarea"
                name="message"
                placeholder="اكتب رسالتك هنا..."
                value={formData.message}
                onChange={handleInputChange}
              />
            </div>

            <button type="submit" className="cu-submit" disabled={isDisabled}>
              {storeLoading
                ? <span className="spinner-border spinner-border-sm" />
                : <IoSendOutline size={18} />
              }
              {t('contact.button')}
            </button>
          </form>
        </div>

      </div>
    </MainLayout>
  );
}

export default ContactUsPage;
